/**
 * @file field-registry.ts
 * @module app/modules/service-request/components/fields/field-registry
 * @description Maps each service request input kind to its implementation. To support a new kind,
 * add it to ServiceRequestFieldKind, write its file in this folder, and register it here.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.2
 * @version 2.1.2
 */

import { ServiceRequestFieldKind } from '../../types/service-request.types';
import { FieldKind, registerFieldKind } from './field-kind';
import { orderRefKeysKind } from './order-ref-keys-field';

const FIELD_KINDS: Record<ServiceRequestFieldKind, FieldKind<unknown>> = {
  orderRefKeys: registerFieldKind(orderRefKeysKind),
};

/** The kind's implementation, or undefined when the server sends a kind this build does not know. */
export const getFieldKind = (kind: string): FieldKind<unknown> | undefined =>
  FIELD_KINDS[kind as ServiceRequestFieldKind];
